import { IHttpService } from "../HttpService";
import Evaluation, { IEvaluation } from "../../model/evaluation/Evaluation";
import EvaluationReview, {
  IEvaluationReview
} from "../../model/evaluation/EvaluationReview";
import EvaluationRuleGroup, {
  IEvaluationRuleGroup
} from "../../model/evaluation/EvaluationRuleGroup";
import EvaluationBusinessRule, {
  IEvaluationBusinessRule
} from "../../model/evaluation/EvaluationBusinessRule";

export interface IEvaluationService {
  getFormEvaluations(formVersionId: number): Promise<IEvaluation[]>;
  executeReportEvaluation(reportId: number): Promise<any>;
  getEvaluationReviews(evaluationId: number): Promise<IEvaluationReview[]>;
  getEvaluationRuleGroups(
    evaluationReviewId: number
  ): Promise<IEvaluationRuleGroup[]>;
  getEvaluationBusinessRules(
    evaluationReviewBusinessRuleGroupId: number
  ): Promise<IEvaluationBusinessRule[]>;
}

const EvaluationService = (httpService): IEvaluationService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/";
  const _evaluationsPath = "evaluations";
  const _formPath = "report";
  const _executePath = "/execute";
  const _reviewsPath = "/reviews";
  const _ruleGroupsPath = "/rule-groups";
  const _businessRulesPath = "/business-rules";

  const EvaluationMapper = (json = []): IEvaluation[] => {
    return json.map((item: any) => {
      let evaluation = Evaluation(item);
      evaluation.id = item.evaluationId;
      evaluation.result = item.evaluationResult;
      evaluation.date = item.evaluationDate;
      return evaluation;
    });
  };

  const EvaluationReviewMapper = (json = []): IEvaluationReview[] => {
    return json.map((item: any) => {
      return EvaluationReview(item);
    });
  };

  const EvaluationRuleGroupMapper = (json = []): IEvaluationRuleGroup[] => {
    return json.map((item: any) => {
      return EvaluationRuleGroup(item);
    });
  };

  const EvaluationBusinessRuleMapper = (
    json = []
  ): IEvaluationBusinessRule[] => {
    return json.map((item: any) => EvaluationBusinessRule(item));
  };

  return {
    async getFormEvaluations(formVersionId: number) {
      const path = _http.buildPath(
        _baseUrl,
        _evaluationsPath,
        _formPath,
        formVersionId.toString()
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return EvaluationMapper(responseJSON);
    },
    async executeReportEvaluation(reportId: number) {
      const path = _http.buildPath(
        _baseUrl,
        _evaluationsPath,
        _executePath,
        reportId.toString()
      );
      const response = await _http.post(path);
      return _http.toText(response);
    },
    async getEvaluationReviews(evaluationId: number) {
      const path = _http.buildPath(
        _baseUrl,
        _evaluationsPath,
        evaluationId.toString(),
        _reviewsPath
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return EvaluationReviewMapper(responseJSON);
    },
    async getEvaluationRuleGroups(evaluationReviewId: number) {
      const path = _http.buildPath(
        _baseUrl,
        _evaluationsPath,
        evaluationReviewId.toString(),
        _ruleGroupsPath
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return EvaluationRuleGroupMapper(responseJSON);
    },
    async getEvaluationBusinessRules(
      evaluationReviewBusinessRuleGroupId: number
    ) {
      const path = _http.buildPath(
        _baseUrl,
        _evaluationsPath,
        evaluationReviewBusinessRuleGroupId.toString(),
        _businessRulesPath
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return EvaluationBusinessRuleMapper(responseJSON);
    }
  };
};

export default EvaluationService;
